import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const className = name => `m2g-customer-loyalty-spoonity-rewards${name || ''}`;

const { Customer, Order } = Mobi2Go;

const Rewards = ({ closeModal }) => {
    const [t] = useTranslation('order.loyalty');
    const [rewards, setRewards] = useState([]);
    const [inCart, setInCart] = useState('');

    useEffect(() => {
        const updateState = () => {
            setRewards(Customer.isLoggedIn() ? Customer.getRewards() : []);
            setInCart(Order.getReward()?.id);
        };

        Customer.bind({
            logIn: updateState,
            updateLoyalty: updateState,
            updateCreditBalance: updateState,
        });

        Order.bind({
            updateReward: updateState
        });

        updateState();

        return () => {
            Customer.unbind({
                logIn: updateState,
                updateLoyalty: updateState,
                updateCreditBalance: updateState,
            });

            Order.unbind({
                updateReward: updateState
            });
        };
    }, []);

    const onRedeemClick = reward => {
        Order.log('click use reward', {
            reward: {
                id: reward.id,
                title: reward.title,
            },
        });
        Order.trigger('updateReward', reward);
        Order.setReward(reward);
        setInCart(reward.id);
        if (closeModal) {
            closeModal()
        }
    };

    const onRemoveClick = reward => {
        Order.trigger('updateReward', reward);
        Order.setReward(null);
        setInCart('');
    }

    return (
        <div className={className()}>

            <h3 className={className('__header')}>{t('available_rewards')}</h3>

            {rewards.length === 0 && (
                <p className={className('__none')}>{t('no_rewards')}</p>
            )}
            {rewards.length > 0 &&
            rewards
                .sort((a, b) => new Date(a.ends_at) - new Date(b.ends_at))
                .map(reward => {
                    const isInCart = inCart === reward.id;

                    return (
                        <div
                            key={reward.id}
                            className={className('__reward')}
                        >
                                <span
                                    className={className(
                                        '__icon m2g-icon m2g-icon--gift'
                                    )}
                                />
                            <div className={className('__lines')}>
                                <div
                                    className={
                                        className('__line') +
                                        ' ' +
                                        className('__line--1')
                                    }
                                >
                                    {reward.description}
                                </div>
                                <div
                                    className={
                                        className('__line') +
                                        ' ' +
                                        className('__line--2')
                                    }
                                >
                                    {reward.title}
                                </div>
                            </div>
                            {isInCart ? (
                                <button
                                    className={className(
                                        '__button m2g-button m2g-button--primary m2g-button--disabled'
                                    )}
                                    onClick={() => onRemoveClick(reward)}
                                >
                                    {t('applied')}
                                </button>
                            ) : (
                                <button
                                    className={className(
                                        '__button m2g-button m2g-button--primary'
                                    )}
                                    onClick={() => onRedeemClick(reward)}
                                >
                                    {t('redeem')}
                                </button>
                            )}
                        </div>
                    );
                })}
        </div>
    );
};

export default Rewards;
